<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900 pt-28 pb-20">
    <div class="container mx-auto px-4 max-w-lg">
      <div
        class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-8 text-center"
      >
        <!-- Icon -->
        <div
          class="w-20 h-20 bg-main/10 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <UIcon
            name="i-lucide-package-search"
            class="w-10 h-10 text-main"
          />
        </div>

        <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Suivre une commande
        </h1>
        <p class="text-gray-500 dark:text-gray-400 mb-8">
          Entrez les informations de votre commande pour voir son statut en
          temps réel.
        </p>

        <!-- Form -->
        <form @submit.prevent="goToOrder" class="space-y-4 text-left">
          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Numéro de commande</label
            >
            <UInput
              v-model="orderId"
              placeholder="Ex: a1b2c3d4-..."
              size="xl"
              icon="i-lucide-hash"
              class="w-full"
            />
          </div>

          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Email</label
            >
            <UInput
              v-model="email"
              type="email"
              placeholder="votre@email.com"
              size="xl"
              icon="i-lucide-mail"
              class="w-full"
            />
          </div>

          <div>
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >Téléphone</label
            >
            <UInput
              v-model="phone"
              type="tel"
              placeholder="06 12 34 56 78"
              size="xl"
              icon="i-lucide-phone"
              class="w-full"
            />
          </div>

          <UButton
            type="submit"
            block
            color="main"
            size="xl"
            :disabled="!isFormValid"
          >
            <UIcon name="i-lucide-search" class="w-4 h-4 mr-2" />
            Rechercher
          </UButton>
        </form>

        <!-- Help -->
        <div
          class="mt-8 rounded-xl bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 p-4 text-left flex gap-3"
        >
          <UIcon
            name="i-lucide-info"
            class="w-5 h-5 text-blue-600 dark:text-blue-400 shrink-0 mt-0.5"
          />
          <p class="text-sm text-blue-700 dark:text-blue-300">
            Votre numéro de commande vous a été envoyé par email après votre
            achat.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const router = useRouter();
const orderId = ref("");
const email = ref("");
const phone = ref("");

const isFormValid = computed(() => {
  return (
    orderId.value.trim().length > 0 &&
    email.value.trim().length > 0 &&
    email.value.includes("@") &&
    phone.value.trim().length > 0
  );
});

const goToOrder = () => {
  if (!isFormValid.value) return;
  router.push({
    path: `/orders/${orderId.value.trim()}`,
    query: {
      email: email.value.trim(),
      phone: phone.value.trim(),
    },
  });
};
</script>
